/// <amd-module name="Widgets/SprintBurndownConfig/IToggleConfigMode" />
/**
 * This interface allows MetaSprintBurndownConfig to interact with multiple implementations of strongly typed Sprint Burndown config experiences.
 * (This avoids a bunch of conditional/casting flows if we mixed both in one implementation.)
 */
export interface IToggleConfigMode {
    /**
     * A hint to the config to put out initial render success or post a widget update (on reload), to push its settings through.
     */
    isReload: boolean;
    onToggleConfig(useLegacy: boolean): void;
}
